"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FIELD_CONSTANTS = require("./mappings/FIELD_CONSTANTS");

/**
 * Custom AJV keyword, validates PrimaryProductInterest
 *
 * usage:
 *     const ajv = ajvErrors(new Ajv({allErrors: true}))
 *     ajv.addKeyword('CountryState', CountryStateKeyword)
 *
 */
var _default = {
  /**
   * @return {boolean}
   */
  validate: function V(schema, data) {
    V.errors = [];
    var mkto = schema.mkto;
    var PrimaryProductInterestField = mkto === "legacy" ? 'PrimaryProductInterest' : 'Primary_Product_Interest__c';
    var PrimaryProductInterest = data[PrimaryProductInterestField];
    var fieldValuMap = (0, _FIELD_CONSTANTS.FIELD_VALUE_MAP)(mkto); //make sure we have a value

    if (!PrimaryProductInterest) {
      V.errors.push({
        keyword: "PrimaryProductInterestList",
        message: "'".concat(PrimaryProductInterestField, "' is required.")
      });
      return false;
    } // Check to see if they may have passed a list in this field


    if (PrimaryProductInterest.includes(';')) {
      //For each item, check to see if it's in the PrimaryProductInterest
      var unknown = PrimaryProductInterest.split(';').map(function (item) {
        return item.trim();
      }) //empty items, is the case when "Citrix ADC;Citrix Workspace;"
      .filter(function (item) {
        return item.length > 0;
      }).filter(function (item) {
        return !fieldValuMap[PrimaryProductInterestField].includes(item);
      });

      if (unknown.length > 0) {
        V.errors.push({
          keyword: "PrimaryProductInterestList",
          message: "List submitted for '".concat(PrimaryProductInterestField, "' contains invalid values (").concat(unknown.join(", "), ").")
        });
        return false;
      } else {
        //all good
        return true;
      }
    }

    if (!fieldValuMap[PrimaryProductInterestField].includes(PrimaryProductInterest)) {
      V.errors.push({
        keyword: "PrimaryProductInterestList",
        message: "'".concat(PrimaryProductInterest, "' is not a valid '").concat(PrimaryProductInterestField, "'.")
      });
      return false;
    }

    return true;
  },
  errors: true
};
exports.default = _default;
//# sourceMappingURL=ProductInterestKeyword.js.map